import { render, staticRenderFns } from "./Procesos.vue?vue&type=template&id=b253ee3c&scoped=true&"
import script from "./Procesos.vue?vue&type=script&lang=js&"
export * from "./Procesos.vue?vue&type=script&lang=js&"
import style0 from "./Procesos.vue?vue&type=style&index=0&id=b253ee3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b253ee3c",
  null
  
)

export default component.exports